import React from 'react'
import styled from 'styled-components'
import GoogleRatingStar from '../../../assets/images/icon_google_star.webp'
import TrustpilotRatingStar from '../../../assets/images/icon_trustpilot.svg'
import TrustpilotLogo from '../../../assets/images/icon_trustpilot_star.webp'
import GoogleLogo from '../../../assets/images/icon_google_shopping.webp'
import TypographyAtom from '../../atoms/typography/typography'
import {brandIvory, brandOrange} from "../../../assets/consts/color";
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import { ROUTES } from '../../../constants/routes'

const Container = styled.li`
    position: relative;
    width: 360px;
    //height: 204px;
    height: 244px;
    flex-shrink: 0;
    margin: 0;
    //padding: 12px 20px;
    padding: 24px;
    /* border: 1px solid gray; */
    //border-radius: 10px;
    //box-shadow: 0px 0px 1px 2px rgba(0, 0, 0, 0.1);
    background: ${brandIvory};

    user-select: none;

    display: flex;
    flex-direction: column;
    gap: 10px;

    p {
        font-size: 14px;
    }

    @media screen and (min-width: 48em) {
        width: 411px;
        height: 272px;
        padding: 32px 40px;
    }

    @media screen and (max-width: 470px) {
        width: 320px;
    }

    &:before {
        background-image: url(${ImageCut});
        background-position: top left;
        background-size: cover;
        content: '';
        height: 30px;
        left: -1px;
        position: absolute;
        top: -1px;
        transform: rotate(180deg);
        width: 30px;
        z-index: 1;
    }
`
const ReviewStarsBlock = styled.div`
    display: flex;
    gap: 8px;
    justify-content: end;
    flex: 1;
    align-items: center;
    /* margin-bottom: 10px; */
`
const ReviewRightBlock = styled.div`

`
const ReviewStarIcon = styled.img`
    width: 12px;
    object-fit: contain;

    @media screen and (min-width: 48em) {
        width: 14px;
    }
`

const ReviewUserBlock = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`
const ProviderIcon = styled.img`
    width: 20px;
    //position: absolute;
    //top: 20px;
    //right: 20px;
    object-fit: contain;

    @media screen and (min-width: 48em) {
        width: 24px;
    }
`
const ReviewProduct = styled.div`
    font-family: Poppins, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #404040;

    grid-column: 1/3;
    
    a {
        text-decoration: none;
        &:hover {
            text-decoration: underline;
            color: ${brandOrange}
        }
    }
`

const ReviewIconList = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`

const ReviewScore = styled.span`
    font-family: Poppins, sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0%;

    //@media screen and (min-width: 48em) {
    //    font-size: 16px;
    //}
`

const UserImageBlock = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    height: 40px;
    width: 40px;

    background-color: #fb7347;
`
const UserInfoBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    p:first-of-type {
    }

    p:last-of-type {
        opacity: 0.6;
    }
`
const UserName = styled(TypographyAtom)`
    font-size: 14px !important;

    //@media screen and (min-width: 48em) {
    //    font-size: 16px !important;
    //}
`
const DateOfReview = styled(TypographyAtom)`
    font-size: 12px !important;

    @media screen and (min-width: 48em) {
        font-size: 14px !important;
    }
`
const ReviewUserImage = styled.div``
const ReviewUserImagePlaceholderWrapper = styled.div`
    p {
        color: white;
    }
`
const ReviewUserImagePlaceholder = styled(TypographyAtom)``
const CommentBlockWrapper = styled.div`
    overflow-y: auto;
    scrollbar-width: thin;

    p {
        margin: 0;
    }
`

const TopWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
`

const CommentBlock = styled(TypographyAtom)`

    //font-style: italic !important;
    font-size: 14px !important;

    //@media screen and (min-width: 48em) {
    //    font-size: 16px !important;
    //}
`

const formatDate = (inputDate) => {
  const date = new Date(inputDate)

  // Format the date to "Month Day, Year"
  const options = {year: 'numeric', month: 'long', day: 'numeric'}
  return date.toLocaleDateString('en-US', options)
}

function TrustedReviewItem({body, created_at, product_handle, product_title, rating, reviewer}) {
  const formattedDate = formatDate(created_at)
  const reviewerName = reviewer.name;
  const userName = reviewerName.length > 15 ? `${reviewerName.substring(0, 15)}...` : reviewerName

  // const isGoogle = type === 'Google'
  const isGoogle = true;

  return (
    <Container>
      <TopWrapper>
        <ReviewUserBlock>
          {/*<UserImageBlock>*/}
          {/*  {userIcon ? (*/}
          {/*    <ReviewUserImage src={userIcon} alt="user" loading="lazy" />*/}
          {/*  ) : (*/}
          {/*    <ReviewUserImagePlaceholderWrapper>*/}
          {/*      <ReviewUserImagePlaceholder*/}
          {/*        type="P"*/}
          {/*        weight="Regular"*/}
          {/*        copy={userName[0]?.toUpperCase() || '?'}*/}
          {/*      />*/}
          {/*    </ReviewUserImagePlaceholderWrapper>*/}
          {/*  )}*/}
          {/*</UserImageBlock>*/}
          <UserInfoBlock>
            <UserName type="P" weight="Bold" copy={userName}/>
            <DateOfReview type="P" weight="Regular" copy={formattedDate}/>
          </UserInfoBlock>
        </ReviewUserBlock>
        <ReviewRightBlock>
          <ReviewStarsBlock>
            <ProviderIcon
              src={isGoogle ? GoogleLogo : TrustpilotLogo}
              alt="provider"
              loading="lazy"
            />
            <ReviewIconList>
              {new Array(rating).fill(null).map((_, index) => (
                <ReviewStarIcon
                  key={index}
                  src={
                    isGoogle ? GoogleRatingStar : TrustpilotRatingStar
                  }
                  alt="star"
                  loading="lazy"
                />
              ))}
            </ReviewIconList>
            <ReviewScore>
              {rating.toFixed(1)}
            </ReviewScore>
          </ReviewStarsBlock>
        </ReviewRightBlock>
        {product_handle && product_title && (
          <ReviewProduct>
            <a href={`${ROUTES.PRODUCTS}/${product_handle}`}>{product_title}</a>
          </ReviewProduct>
        )}
      </TopWrapper>
      <CommentBlockWrapper>
        <CommentBlock type="P" weight="Regular" copy={body}/>
      </CommentBlockWrapper>
    </Container>
  )
}

export default TrustedReviewItem
